var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:`ui__btn btn--${_vm.color} ${_vm.icon ? 'btn--icon' : ''} ${_vm.disabled || _vm.loading ? 'btn--disabled' : ''}`,attrs:{"disabled":_vm.disabled || _vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.loading)?_c('div',{staticClass:"spinner"}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }